module.exports = __webpack_public_path__ + "files/ae8230f1ceb9fdbc93222dcc3326830c.png";